






















import { Component, Vue } from "vue-property-decorator";

@Component
export default class FileSelector extends Vue {
  file?: File;

  isFileSelected = false;

  setFile(file: File) {
    if (file) {
      this.file = file;
      this.isFileSelected = true;
    }
  }

  processFile() {
    if (this.file) {
      this.$emit("data-file-changed", this.file);
    }
  }
}
